import React from "react";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { NavbarTwo } from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import pistonSeal from "../asset/productlist/pistonrodseals.png";
import metallicSeal from "../asset/productlist/metallicfaceseals.png";
import precisionComponent from "../asset/productlist/precisioncomponents.png";
import coating from "../asset/productlist/Coating&plating.png";
import assembly from "../asset/productlist/Precisionassemblies.png";
import sealDetail from "../asset/productlist/indigenouslydevelopedseals.png";
import "./ProductsPage.css";

const categories = [
  { title: "Piston rod seals", image: pistonSeal, link: "/piston-rod-seals", size: "wide", slug: "piston" },
  { title: "Metallic face seals", image: metallicSeal, link: "/metallic-face-seals", size: "wide", slug: "metallic" },
  { title: "Precision components", image: precisionComponent, link: "/precision-component", size: "standard", slug: "precision" },
  { title: "Coating & plating", image: coating, link: "/coating-and-plating", size: "standard", slug: "coating" },
  { title: "Indigenously developed assemblies", image: sealDetail, link: "/indigenously-developed-assemblies", size: "featured", slug: "assembly" },
  { title: "Assemblies", image: assembly, link: "/assemblies", size: "standard", slug: "assemblies" },
];

const ProductTile = ({ category }) => (
  <Link to={category.link} className={`product-category product-category--${category.size} ${category.slug ? `product-category--${category.slug}` : ""}`}>
    <img src={category.image} alt="" aria-hidden="true" />
    <span className="product-category__wash" />
    <h2>{category.title}</h2>
    <ArrowLongRightIcon className="product-category__arrow" />
  </Link>
);

const ProductsPage = () => (
  <div className="products-page">
    <NavbarTwo />
    <main className="products-page__main">
      <section className="products-catalog" aria-labelledby="products-title">
        <div className="products-catalog__intro">
          <p>What we make</p>
          <h1 id="products-title">Products</h1>
          <span>Precision engineered for demanding applications.</span>
        </div>
        <div className="products-catalog__grid">
          {categories.map((category) => <ProductTile category={category} key={category.title} />)}
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default ProductsPage;
